import { Ref, Button } from "@tblabs/truffle";
import { BasketItemType } from "../../../Models/Basket/BasketItemType";
import { Box } from "./Box";
import { Product } from "../../../Models/Product/Product";


export class RentOrSaleBox extends Box
{
    constructor(product: Product, rentOrSale: Ref<BasketItemType>)
    {
        if (product.Basketable.value)
        {
            super("product__actions-tabs", []);
            return;
        }

        if (!product.Rentable.value)
            rentOrSale.value = BasketItemType.Sale;
        if (!product.Saleable.value)
            rentOrSale.value = BasketItemType.Rent;

        super("product__actions-tabs", [
            product.Rentable.value && new Button("Wypożyczenie")
                .OnClick(() => rentOrSale.value = BasketItemType.Rent)
                .Class("product__actions-tab")
                .Attribute("data-testid", "rent-btn")
                .When(rentOrSale, (m) => m == BasketItemType.Rent,
                    x => x.RemoveClass("product__actions-tab--inactive").Class("product__actions-tab--active"),
                    x => x.RemoveClass("product__actions-tab--active").Class("product__actions-tab--inactive")),
            product.Saleable.value && new Button("Zakup")
                .OnClick(() => rentOrSale.value = BasketItemType.Sale)
                .Class("product__actions-tab")
                .Attribute("data-testid", "sale-btn")
                .When(rentOrSale, (m) => m == BasketItemType.Sale,
                    x => x.RemoveClass("product__actions-tab--inactive").Class("product__actions-tab--active"),
                    x => x.RemoveClass("product__actions-tab--active").Class("product__actions-tab--inactive")),
        ]);
    }
}
